import { FilterFilled } from "@ant-design/icons";
import { TreeSelect } from "antd";
import { ColumnsType } from "antd/es/table";
import classNames from "classnames";
import { AddNewRole } from "shared/api";
import { TableButton, TableSearchFilter } from "shared/ui";

interface PermissionItem {
  name: string;
  permission_blocks: string[];
}

interface PermissionTableProps {
  t: Function;
  editRolesHandler: (record: AddNewRole) => void;
  filterByName: {
    value: string;
    onChange: (e: string | React.ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
  };
  filterByPermission: {
    treeData: any;
    value: string[];
    onChange: React.Dispatch<React.SetStateAction<string[]>>;
    onClear: () => void;
  };
}

export const useGetPermissionsAndRolesColumns = ({
  t,
  editRolesHandler,
  filterByName,
  filterByPermission,
}: PermissionTableProps): ColumnsType<PermissionItem> => [
  {
    title: t("Name"),
    render: (record: AddNewRole) => (
      <TableButton
        type="title"
        title={record?.name}
        onClick={() => editRolesHandler(record)}
      />
    ),
    filterIcon: (
      <FilterFilled
        className={classNames({
          "!text-blue-600 scale-125": filterByName.value.length > 0,
        })}
      />
    ),
    filterDropdown: ({ setSelectedKeys, confirm, visible }) => (
      <TableSearchFilter
        setSelectedKeys={setSelectedKeys}
        clearFilters={filterByName.onClear}
        confirm={confirm}
        value={filterByName.value}
        handleFilterChange={filterByName.onChange}
        visible={visible}
        placeholder={t("Search Name")}
        title={t("Filter by Name")}
      />
    ),
  },
  {
    title: t("Permission Blocks"),
    key: "permission_blocks",
    dataIndex: "permission_blocks",
    render: (blocks: string[]) => blocks?.join(", "),
    filterIcon: (
      <FilterFilled
        className={classNames({
          "!text-green-600 scale-125": filterByPermission.value.length > 0,
        })}
      />
    ),
    filterDropdown: () => (
      <div style={{ padding: 8, width: 250 }}>
        <TreeSelect
          style={{ width: "100%" }}
          treeData={filterByPermission.treeData}
          placeholder={t("Select permissions")}
          value={filterByPermission.value}
          onChange={filterByPermission.onChange}
          allowClear
          treeCheckable
          showCheckedStrategy={TreeSelect.SHOW_CHILD}
        />
      </div>
    ),
  },
];
